// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-intro__container--desktop {
}

.company-intro__logo-bg--desktop {
    width: 45%;
}

.company-intro__container--mobile {
    width: 100%;
}

.company-intro__logo-bg--mobile {
    display: block;
}

.login-page__intro .company-intro__wrapper--mobile {
    justify-content: center !important;
}

.app-header__logo-container {
    justify-content: flex-start !important;
}

.app-header__logo {
    flex-basis: 140px !important;
    height: 60px !important;
    margin: 0 auto 0 16px !important;
}

.app-header__logo > svg > g > path:nth-child(1) {
    fill: #5b6073;
}

.dashboard-mobile.notification-area.dashboard-area .list-item__icon-text > button {
    background-color: var(--app-fill-color-primary-one) !important;
}

.dashboard-mobile.notification-area.dashboard-area .list-item__background {
    background-color: var(--app-fill-color-primary-one) !important;
}

.dashboard-mobile.notification-area.dashboard-area .list-item__icon-text .labeled-text__primary {
    color: var(--app-fill-color-primary-one) !important;
}

.notification-area.dashboard-area .list-item__background {
    background-color: var(--app-fill-color-primary-one) !important;
}

.notification-area.dashboard-area .list-item__icon-text > button {
    background-color: var(--app-fill-color-primary-one) !important;
}

.notification-area.dashboard-area .list-item__icon-text .labeled-text__primary {
    color: var(--app-fill-color-primary-one) !important;
}

.extra-service-buttons-list-home-area.dashboard-area .extra-service-button__icon-container > div > svg > path {
    fill: var(--app-fill-color-primary-one) !important;
}

.dashboard-area__action-btn-container > button {
    background-color: var(--app-fill-color-secondary-two) !important;
}

.document-totals-block .invoice__view-pdf-btn > span.document-totals__item-value {
    color: var(--app-fill-color-primary-one) !important;
}

.invoice-block.document__actions-block .main-action-btn invoice__view-pdf-btn {
    background-color: var(--app-fill-color-primary-one) !important;
}

.extra-service-button__button {
    color: black !important;
}

#invoice-payment-button {
    background-color: var(--app-fill-color-primary-one) !important;
}

#invoice-payment-button .main-action-btn__label-text {
    color: white !important;
}

.public-page__content-container-content {
    width: auto;
}

.tenant-registration-form__header .app-logo svg {
    margin-left: -70px !important;
}

.company-intro__logo--desktop svg {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/resources/tty/addition.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf","sourcesContent":[".company-intro__container--desktop {\n}\n\n.company-intro__logo-bg--desktop {\n    width: 45%;\n}\n\n.company-intro__container--mobile {\n    width: 100%;\n}\n\n.company-intro__logo-bg--mobile {\n    display: block;\n}\n\n.login-page__intro .company-intro__wrapper--mobile {\n    justify-content: center !important;\n}\n\n.app-header__logo-container {\n    justify-content: flex-start !important;\n}\n\n.app-header__logo {\n    flex-basis: 140px !important;\n    height: 60px !important;\n    margin: 0 auto 0 16px !important;\n}\n\n.app-header__logo > svg > g > path:nth-child(1) {\n    fill: #5b6073;\n}\n\n.dashboard-mobile.notification-area.dashboard-area .list-item__icon-text > button {\n    background-color: var(--app-fill-color-primary-one) !important;\n}\n\n.dashboard-mobile.notification-area.dashboard-area .list-item__background {\n    background-color: var(--app-fill-color-primary-one) !important;\n}\n\n.dashboard-mobile.notification-area.dashboard-area .list-item__icon-text .labeled-text__primary {\n    color: var(--app-fill-color-primary-one) !important;\n}\n\n.notification-area.dashboard-area .list-item__background {\n    background-color: var(--app-fill-color-primary-one) !important;\n}\n\n.notification-area.dashboard-area .list-item__icon-text > button {\n    background-color: var(--app-fill-color-primary-one) !important;\n}\n\n.notification-area.dashboard-area .list-item__icon-text .labeled-text__primary {\n    color: var(--app-fill-color-primary-one) !important;\n}\n\n.extra-service-buttons-list-home-area.dashboard-area .extra-service-button__icon-container > div > svg > path {\n    fill: var(--app-fill-color-primary-one) !important;\n}\n\n.dashboard-area__action-btn-container > button {\n    background-color: var(--app-fill-color-secondary-two) !important;\n}\n\n.document-totals-block .invoice__view-pdf-btn > span.document-totals__item-value {\n    color: var(--app-fill-color-primary-one) !important;\n}\n\n.invoice-block.document__actions-block .main-action-btn invoice__view-pdf-btn {\n    background-color: var(--app-fill-color-primary-one) !important;\n}\n\n.extra-service-button__button {\n    color: black !important;\n}\n\n#invoice-payment-button {\n    background-color: var(--app-fill-color-primary-one) !important;\n}\n\n#invoice-payment-button .main-action-btn__label-text {\n    color: white !important;\n}\n\n.public-page__content-container-content {\n    width: auto;\n}\n\n.tenant-registration-form__header .app-logo svg {\n    margin-left: -70px !important;\n}\n\n.company-intro__logo--desktop svg {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
